import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ENV, VERSION } from '../../../../environments/environment';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { WebSocketService } from '../../../auxiliares/servicios/websocket';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private router = inject(Router);
  private authService = inject(AuthService);
  private helperService = inject(HelperService);
  private wss = inject(WebSocketService);

  public loading = false;
  public loginForm?: UntypedFormGroup;
  public loginTitle = 'Bienvenidos a Novit';
  public loginText = 'Seguridad digital.';
  public version = VERSION;
  public env = ENV;
  public hide = true;

  public async onSubmit() {
    try {
      if (this.loginForm?.valid) {
        this.loading = true;
        const username = this.loginForm.get('username')?.value;
        const password = this.loginForm.get('password')?.value;
        await this.authService.login(username, password);
        this.wss.initWs();
        this.router.navigateByUrl('main');
        this.loading = false;
      } else {
        this.helperService.notifWarn(
          'Debe ingresar un usuario y una contraseña',
        );
      }
    } catch (error) {
      console.error(error);
      this.helperService.notifError(error);
      this.loading = false;
    }
  }

  ngOnInit(): void {
    this.authService.logout();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
}
